<div class="pt-3 pl-3 pl-sm-4">
  <dx-button (click)="navigateBack()" icon="back" text="{{ 'Back' | transloco }}"></dx-button>
</div>

<nida-web-site-wrapper [translatedHeadline]="'404 Not found' | transloco">
  <nida-web-card [disableHeadline]="true" class="mt-3"> {{ 'Page not found' | transloco }}</nida-web-card>
</nida-web-site-wrapper>
